export default __webpack_public_path__ + "static/media/404.bebe24e1.png";